import {Base} from "@/api/Base"

export class EmployeeAdd extends Base {
    path = "employee/add"
}